import {creates, elementFactory, hoistCmp} from '@xh/hoist/core';
import {EconomicCalendarWidgetModel} from './EconomicCalendarWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import ReactCountryFlag from 'react-country-flag';
import './EconomicCalendarWidget.scss';
import {placeholder} from '@xh/hoist/cmp/layout';
import {Icon} from '@xh/hoist/icon';
import {widgetToolbar} from '../../../../cmp/widget/WidgetToolbar';
import {widgetToolbarLabel} from '../../../../cmp/widget/WidgetToolbarLabel';
import {widgetToolbarSelect} from '../../../../cmp/widget/WidgetToolbarSelect';
import {EconomicEventTypeEnum} from '../../../../data/DataTypes';

export const economicCalendarWidget = hoistCmp.factory({
    model: creates(() => EconomicCalendarWidgetModel),
    render({model}) {
        const {type} = model;
        return panel({
            className: 'economic-calendar',
            items: type
                ? grid({agOptions: {suppressColumnMoveAnimation: true, ...model.agOptions}})
                : placeholder(Icon.gear(), 'Configure'),
            bbar: type ? bbar() : null,
            mask: 'onLoad'
        });
    }
});

const COUNT_OPTIONS = [
    {value: -1, label: 'Auto'},
    {value: 5, label: 'top 5'},
    {value: 10, label: 'top 10'},
    {value: 15, label: 'top 15'},
    {value: 20, label: 'top 20'}
];

const bbar = hoistCmp.factory<EconomicCalendarWidgetModel>(({model}) => {
    const {type} = model;
    const symbolState = model.gridModel.columnState.find(s => s.colId === 'symbol');
    const countLabel = symbolState && !symbolState.hidden ? 'tickers' : 'events';
    const countSelect = widgetToolbarSelect({title: 'Count', options: COUNT_OPTIONS, bind: 'count'});

    if (type === EconomicEventTypeEnum.Economic) {
        return widgetToolbar({
            items: [
                widgetToolbarLabel(countLabel),
                countSelect,
                widgetToolbarLabel('country'),
                widgetToolbarSelect({
                    title: 'Country',
                    options: [{value: null, label: 'All'}, ...model.countryOptions],
                    bind: 'country'
                })
            ]
        });
    }
    if (type === EconomicEventTypeEnum.Dividends) {
        return widgetToolbar({
            items: [
                widgetToolbarLabel(countLabel),
                countSelect,
                widgetToolbarLabel('frequency'),
                widgetToolbarSelect({
                    title: 'Frequency',
                    options: [{value: null, label: 'All'}, ...model.frequencyOptions],
                    bind: 'frequency'
                })
            ]
        });
    }
    if (type === EconomicEventTypeEnum.Earnings) {
        return widgetToolbar({
            items: [widgetToolbarLabel(countLabel), countSelect]
        });
    }
    if (type === EconomicEventTypeEnum.IPOs) {
        return widgetToolbar({
            items: [
                widgetToolbarLabel(countLabel),
                countSelect,
                widgetToolbarLabel('exchange'),
                widgetToolbarSelect({
                    title: 'Exchange',
                    options: [{value: null, label: 'All'}, ...model.exchangeOptions],
                    bind: 'exchange'
                })
            ]
        });
    }
    if (type === EconomicEventTypeEnum.Splits) {
        return widgetToolbar({
            items: [
                widgetToolbarLabel(countLabel),
                countSelect,
                widgetToolbarLabel('split type'),
                widgetToolbarSelect({
                    title: 'Split Type',
                    options: [{value: null, label: 'All'}, ...model.splitTypeOptions],
                    bind: 'splitType'
                })
            ]
        });
    }
    return null;
});

export const flagRenderer = elementFactory(ReactCountryFlag);
